import React, { useEffect } from 'react';

import { requestPin } from 'flow/actions/meeting-actions';
import BaseModal, { modalSizes } from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';
import MeetingJoinOnAnotherDeviceCodes from '../shared/MeetingJoinOnAnotherDeviceCodes';

type Props = {
    meetingCode: string;
    dialInNumber?: string;
    pin?: string;
    conferenceLink?: string;
    onClose: () => void;
};

/**
 * The lobby's way of offering the codes for another device, showing the same
 * two the meeting does (AC-1691).
 *
 * A dialog rather than the meeting's floating card: that card is positioned
 * against the meeting's side panel, which the lobby does not have, and there
 * is nothing behind the lobby worth keeping in view.
 *
 * Asks for the PIN, which the meeting already has by this point but the lobby
 * only fetches when someone reveals it — without this, the dial-in code would
 * be missing for anyone who had not.
 */
const MeetingLobbyJoinOnAnotherDeviceModal = ({
    meetingCode,
    dialInNumber,
    pin,
    conferenceLink,
    onClose,
}: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!pin) {
            dispatch(requestPin(meetingCode));
        }
    }, [dispatch, meetingCode, pin]);

    return (
        <BaseModal
            open={true}
            header={i18next.t('videoconference.lobby.join_other_device')}
            modalSize={modalSizes.SMALL_MEDIUM}
            disableActions={true}
            onClose={onClose}
        >
            <div className="p-6">
                <MeetingJoinOnAnotherDeviceCodes
                    dialInNumber={dialInNumber}
                    pin={pin}
                    conferenceLink={conferenceLink}
                />
            </div>
        </BaseModal>
    );
};

export default MeetingLobbyJoinOnAnotherDeviceModal;
